import { Directive, Output , HostListener, ElementRef, EventEmitter } from '@angular/core';
import { ExpertRimOptions } from './expert-rim.component';

@Directive({
  selector: '[rimPlaceholderNullOnClick]'
})

export class RimPlaceholderNull {
   constructor(private _elementRef : ElementRef , private expRimOptions : ExpertRimOptions) {
    }

    @Output()
    public rimPlaceholderNullOnClick = new EventEmitter();

 /* To capture all clicks on the host element of the document and 
 check if the click is inside or outside of the element*/
    @HostListener('document:click', ['$event','$event.target'])
    public onClick(event: MouseEvent, targetElement:HTMLElement) {
        if(!this._elementRef.nativeElement.contains(targetElement))
        {               
            this.expRimOptions.expertRimOptions="";
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-rim/expert-rim-placeholder-null.ts